<template>

  <div :class="{svgwrap:true,active:active}">
    <span class="label" v-html="label" />
    <Icon :type="type" class="svg" :colour="active?'#f1492a':''" />
  </div>

</template>

<script>
import Icon from './Icon.vue'
export default {
  name: 'FeatureIcon',
  components: {Icon},
  props: {
    type: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    settings () {
      switch ( this.type ) {

        case 'paid' : return { icon: 'dollar-sign', label: 'Paid', solid: true };
        case 'answer_box' : return { icon: 'align-left', label: 'Answer Box', solid: true };
        case 'local_pack' :  return { icon: 'map-marker-alt', label: 'Local Pack', solid: true };
        case 'knowledge_graph' : return { icon: 'brain', label: 'Knowledge Graph', solid: true };
        case 'featured_snippet' : return { icon: 'quote-right', label: 'Featured Snippet', solid: true };
        case 'top_stories' : return { icon: 'newspaper', label: 'Top Stories', solid: true };
        case 'map' : return { icon: 'map', label: 'Map', solid: true };
        case 'google_flights' : return { icon: 'plane-departure', label: 'Flights', solid: true };
        case 'images' : return { icon: 'images', label: 'Images', solid: false };
        case 'shopping' : return { icon: 'shopping-basket', label: 'Shopping', solid: true };
        case 'jobs' : return { icon: 'briefcase', label: 'Jobs', solid: true };
        case 'events' : return { icon: 'calendar-check', label: 'Events', solid: false };
        case 'mention_carousel' : return { icon: 'portrait', label: 'Mention Carousel', solid: true };
        case 'multi_carousel' : return { icon: 'portrait', label: 'Mention Carousel', solid: true };
        case 'recipes' : return { icon: 'utensils', label: 'Recipes', solid: true };
        case 'top_sights' : return { icon: 'mountain', label: 'Top Sights', solid: true };
        case 'scholarly_articles' : return { icon: 'book', label: 'Scholarly Articles', solid: true };
        case 'popular_products' : return { icon: 'fire-alt', label: 'Popular Products', solid: true };
        case 'podcasts' : return { icon: 'microphone-alt', label: 'Podcasts', solid: true };
        case 'multi_carousel' : return { icon: 'portrait', label: 'Multi Carousel', solid: true };
        case 'carousel' : return { icon: 'portrait', label: 'Carousel', solid: true };
        case 'google_reviews' : return { icon: 'star-half-alt', label: 'Reviews', solid: true };
        case 'google_posts' : return { icon: 'pencil-alt', label: 'Posts', solid: true };
        case 'hotels_pack' : return { icon: 'hotel', label: 'Hotels Pack', solid: true };
        case 'people_also_ask' : return { icon: 'question-circle', label: 'People Also Ask', solid: true };
        case 'related_searches' : return { icon: 'angle-double-right', label: 'Related Searches', solid: true };
        case 'people_also_search' : return { icon: 'copy', label: 'People Also Search', solid: true };
        case 'twitter' : return { icon: ['fab','twitter'], label: 'Twitter', solid: true };
        case 'video' : return { icon: 'video', label: 'Video', solid: true };
        case 'short_videos' : return { icon: 'video', label: 'Short Videos', solid: true };
        case 'questions_and_answers' : return { icon: 'question', label: 'Questions And Answers', solid: true };
        case 'find_results_on' : return { icon: ['fab','searchengin'], label: 'Find Results On', solid: false };
        case 'stocks_box' : return { icon: 'chart-line', label: 'Stocks Box', solid: true };
        case 'visual_stories' : return { icon: 'eye', label: 'Visual Stories', solid: false };
        case 'commercial_units' : return { icon: 'warehouse', label: 'Commercial Units', solid: true };
        case 'local_services' : return { icon: 'wrench', label: 'Local Services', solid: true };
        case 'google_hotels' : return { icon: 'hotel', label: 'Hotels', solid: true };
        case 'ai_overview' : return { icon: 'ai', label: 'AI Overview', solid: true };
        case 'explore_brands' : return { icon: 'brands', label: 'Explore Brands', solid: true };

      }
      return false;
    },
    label () {
      return this.settings.label + ( this.active ? ' - for this domain!' : '' );
    }
  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.svgwrap {
  color: @darkContrast;
  margin: 0 4px 4px 0;
  height: 14px;
  width: auto;
  display: inline-block;
  position: relative;
  .trans;
  .svg {
    height: 100%;
    width: auto;
    opacity:0.35;
  }
  .label {
    display: block;
    position: absolute;
    top: -16px;
    right: 0;
    display: none;
    white-space: nowrap;
    line-height: 1;
    background-color: @darkContrast;
    color: #fff;
    padding: 2px 3px;
    .rounded(2px);
  }
  &.active {
    .svg {
      opacity:1 !important;
    }
     .label {
      background-color: @formDefaultColour;
     }
  }
  &:hover {
    .svg {
      opacity:0.7;
    }
    .label {
      display: block;
    }
  }
}
</style>